/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { DetachedRouteHandle } from '@angular/router';
import { Subject, Observable, observeOn, asapScheduler, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DetachedRouteHandlesService {

  public storeObjectString: Map<string, DetachedRouteHandle>;
  public storeComponent: Map<any, DetachedRouteHandle>;

  protected changesComponent: Subject<Map<any, DetachedRouteHandle>>;
  protected changesComponent$: Observable<Map<any, DetachedRouteHandle>>;

  protected changesObjectString: Subject<Map<string, DetachedRouteHandle>>;
  protected changesObjectString$: Observable<Map<string, DetachedRouteHandle>>;

  constructor() {
    this.storeComponent = new Map();
    this.changesComponent = new Subject();
    this.changesComponent$ = this.changesComponent.asObservable();

    this.storeObjectString = new Map();
    this.changesObjectString = new Subject();
    this.changesObjectString$ = this.changesObjectString.asObservable();
  }
  
  public getChangesByComponent$(component: any): Observable<{ changes: Map<any, DetachedRouteHandle>, component: any }> {
    return this.changesComponent$.pipe(observeOn(asapScheduler), map((changes) => ({ changes, component })))
  }
  
  public getChangesByObjectString$(srt: string): Observable<{ changes: Map<string, DetachedRouteHandle>, srt: string }> {
    return this.changesObjectString$.pipe(observeOn(asapScheduler), map((changes) => ({ changes, srt })))
  }

  public set(component: any, srt: string, handle: DetachedRouteHandle): void {
    this.storeComponent.set(component, handle);
    this.storeObjectString.set(srt, handle);
    this.next();
  }

  public delete(component: any, srt: string): void {
    this.storeComponent.delete(component);
    this.storeObjectString.delete(srt);
    this.next();
  }

  public getByComponent(component: any): DetachedRouteHandle | null {
    return this.storeComponent.get(component);
  }

  public getByObjectString(srt: string): DetachedRouteHandle | null {
    return this.storeObjectString.get(srt);
  }

  public hasByComponent(component: any): boolean {
    return this.storeComponent.has(component);
  }

  public hasByObjectString(srt: string): boolean {
    return this.storeObjectString.has(srt);
  }

  public clear(): void {
    this.storeComponent.clear();
    this.storeObjectString.clear();
    this.next();
  }

  private next(): void {
    this.changesComponent.next(this.storeComponent);
    this.changesObjectString.next(this.storeObjectString);
  }
}
